import {
  CustomerActivityType,
  CustomerDataSource,
} from "@redotech/redo-model/marketing/segments/segment-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getSegmentCollections = {
  name: "getSegmentCollections" as const,
  input: z.object({
    dataStructureType: createEnum(CustomerActivityType),
    dataStructureField: z.string().optional(),
    dataStructureFieldSource: createEnum(CustomerDataSource).optional(),
  }),
  output: z.array(
    z.object({
      id: z.string(),
      handle: z.string(),
      title: z.string(),
      productCount: z.number().optional(),
    }),
  ),
};
